<template>
    <v-dialog v-model="isActive" width="400px" scrollable transition="dialog-bottom-transition" persistent>
        <v-card class="rounded-0 pa-4">
            <v-card-text class="d-flex align-center justify-center flex-column text-body-1 black--text pa-5">
                <v-icon size="120" color="orange">mdi-alert-circle-outline</v-icon>
                <v-card-title class="font-weight-bold text-h6 justify-center">
                    {{ titulo }}</v-card-title>
                <!-- Por favor, revise si su número de matrícula es correcto antes de continuar. -->
                {{ msg }}
            </v-card-text>
            <div class="d-flex flex-column justify-center align-center text-center mx-9">
                <v-btn class="py-5" block elevation="0" color="primary" @click="confirmAndClose(true)">
                    {{ msgAceptar }}
                </v-btn>
                <v-btn class="py-5 mt-1" block outlined color="secondary" @click="confirmAndClose(false)">
                    {{ msgCancelar }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['msgAceptar', 'msgCancelar', 'msg', 'titulo'],
    data() {
        return {
            isActive: false,
            callback: null,
        }
    },
    computed: {
        /*         ...mapGetters('preafiliacion', ['matricula']), */
    },
    methods: {
        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },

        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
    }
}

</script>